import React, { useState } from "react";
import { ContainerMedia } from "./ImagenProductoStyled";
import { useAppSelector } from "../../../../../hooks/customReduxHooks";
var ImagenProducto = function (_a) {
    var _b, _c;
    var producto = _a.producto, onClick = _a.onClick, showTitle = _a.showTitle, contextoVisual = _a.contextoVisual, children = _a.children;
    var _d = useState(false), hover = _d[0], setHover = _d[1];
    var componentes = useAppSelector(function (state) { var _a, _b; return (_b = (_a = state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData) === null || _b === void 0 ? void 0 : _b.componentes; });
    return (React.createElement(ContainerMedia, { className: "imagen-producto ".concat(hover &&
            ((_b = producto.videos) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
            componentes.AUTOPLAY_VIDEO_HOVER &&
            "hasVideo"), contextoVisual: contextoVisual, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
        React.createElement("a", { href: producto.urlseo, onClick: function (e) { return onClick(e); } }, hover &&
            ((_c = producto.videos) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
            componentes.AUTOPLAY_VIDEO_HOVER ? (React.createElement("video", { className: "media", muted: true, autoPlay: true, controlsList: "nodownload" },
            React.createElement("source", { src: producto.videos[0].url }))) : (React.createElement("img", { src: producto.foto, loading: "lazy", alt: producto.foto_alt, title: showTitle && producto.foto_alt }))),
        children));
};
export default ImagenProducto;
